import { render, staticRenderFns } from "./_CreateNote.vue?vue&type=template&id=bca7d0b8&"
import script from "./_CreateNote.vue?vue&type=script&lang=ts&"
export * from "./_CreateNote.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports